import axios from "axios";
import { MessageBox, Message } from "element-ui";
import { getToken } from "./auth";
import { Loading } from "element-ui";

// 请求计数器
let activeRequests = 0;
let loadingInstance = null;

// 管理loading状态
const loading = {
    // 显示全局loading
    show() {
        if (!loadingInstance) {
            loadingInstance = Loading.service({
                fullscreen: true,
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        }
    },

    // 隐藏loading
    hide() {
        if (loadingInstance) {
            loadingInstance.close();
            loadingInstance = null;
        }
    },

    // 开始新请求
    start() {
        if (activeRequests === 0) {
            this.show();
        }
        activeRequests++;
    },

    // 结束请求
    end() {
        activeRequests--;
        if (activeRequests === 0) {
            this.hide();
        }
    }
};

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // 跨域请求时发送Cookie
    timeout: 60 * 1000 // 请求超时
});

// 请求拦截器
service.interceptors.request.use(
    (config) => {
        if (config.contentType) {
            config.headers["Content-Type"] = config.contentType;
        }
        // 显示loading，除非明确跳过
        if (config.skipLoading !== true) {
            loading.start();
        }
        config.headers["userId"] = getToken();
        config.headers["Authorization"] = sessionStorage.getItem("Authorization");
        return config;
    },
    (error) => {
        loading.end();
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    (response) => {
        // 请求完成，减少计数
        if (response.config.skipLoading !== true) {
            loading.end();
        }
        const res = response.data;
        if (Number(res.code) === 200) {
            return res;
        }
        return Promise.reject(res);
    },
    (error) => {
        // 请求失败，减少计数
        if (error.config && error.config.skipLoading !== true) {
            loading.end();
        }
        return Promise.reject(error);
    }
);

export default service;
